import countriesSlice from './countries.slice'
import { moduleName } from './countries.types'

export const actionTypes = {
  FETCH_COUNTRIES: `${moduleName}/FETCH_COUNTRIES`,
}

const fetchCountries = () => ({
  type: actionTypes.FETCH_COUNTRIES,
})

const { fetchStart, fetchFailure, fetchSuccess } = countriesSlice.actions

export { fetchCountries, fetchFailure, fetchStart, fetchSuccess }
